import { render, staticRenderFns } from "./SkillChip.vue?vue&type=template&id=52b605c9&scoped=true&"
import script from "./SkillChip.vue?vue&type=script&lang=js&"
export * from "./SkillChip.vue?vue&type=script&lang=js&"
import style0 from "./SkillChip.vue?vue&type=style&index=0&id=52b605c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b605c9",
  null
  
)

export default component.exports